import React, {useState} from 'react';
import { useGrants } from '../../Data/Users';
import Icon from '../../Components/Icons/Icon';
import { useSession } from '../../Components/Session';
import Modal from '../../Components/Modal';
import Loading from '../../Components/Loading';
import API from '../../Services/API';
import { useToasts } from '../../Components/Toasts';
import { useJournalCounts } from '../../Data/Journal';

const BusinessSwitcher = () => {
    const {grants} = useGrants();
    const {business} = useSession();
    const {counts} = useJournalCounts();

    const [switcherOpen, setSwitcherOpen] = useState(false);

    if (!grants || !business) {
        // Don't return nothing, as this will cause the top bar to jump around
        return <Icon icon="UserHelmetSafety"
            className="fill-muted"
            size="2x"
        />;
    }

    // const currentGrant = grants.find(grant => grant.businessId === business.id);
    const allNotifications = counts ?
        counts.reduce((acc, count) => count.businessId === business.id ? acc : acc + count.count, 0) : 0;

    return <>
        {/* <LogoOrIcon {...{logo: currentGrant.logo, bade: allNotifications, onClick: () => setSwitcherOpen(true)}} /> */}
        <Icon icon="UserHelmetSafety"
            className="fill-brand"
            size="2x"
            onClick={() => setSwitcherOpen(true)}
            badge={allNotifications}
        />
        <TheSwitcher {...{switcherOpen, setSwitcherOpen, grants, counts}} />
    </>
}

const LogoOrIcon = ({logo, badge, onClick}) => {
    if (logo) {
        return <Logo url={logo} badge={badge} onClick={onClick} />
    }

    return <Icon icon="UserHelmetSafety" className="fill-brand" size="2x" onClick={onClick} badge={badge} />
}

const TheSwitcher = ({switcherOpen, setSwitcherOpen, grants, counts}) => {
    const [switching, setSwitching] = useState(null);
    const {showError} = useToasts();

    const switchToGrant = (grantId) => {
        setSwitching(grantId);
        API.switchAccount(grantId).then(() => {
            // The API call will reload the page, so nothing more to do
            return null;
        }).catch(err => {
            setSwitching(null);
            showError(API.parseError(err));
        });
    }

    return <Modal isOpen={switcherOpen} setIsOpen={setSwitcherOpen} title="Switch accounts" dismissible>
        {grants.map(grant => {
            const notifications = counts ? counts.find(c => c.businessId === grant.businessId).count : null;

            return <button
                key={grant.id}
                className="w-full my-3 py-3 px-6 flex items-center border rounded-xl focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50"
                onClick={() => switchToGrant(grant.id)}
                disabled={!!switching || API.jwt('grantId') === grant.id}
            >
                <LogoOrIcon logo={grant.logo} badge={notifications} />

                <span className="grow ml-4 text-left">
                    <strong>{grant.businessName}</strong>
                    <br />
                    <span className="text-gray-500">{grant.role}</span>
                </span>
                <span className="grow-0 h-full">
                    {switching !== grant.id && <Icon size="2x" icon="ArrowRightToBracket" />}
                    {switching === grant.id && <Loading size="2x" inline={true} />}
                </span>
            </button>
        })}

        <p className="my-4 w-full mx-auto text-center text-muted text-sm text-balance">
            To access other accounts the account owner must add your email address as an additional user.
        </p>
    </Modal>
}

const Logo = ({url, badge, onClick}) => {
    return <div className="rounded-lg w-14 h-14 bg-cover bg-center border relative"
        style={{backgroundImage: `url(${url})`}}
        onClick={() => onClick && onClick()}
    >
        {badge ? <div className="absolute top-0 right-0 -mt-1 -mr-1 rounded-full px-1 min-w-4 h-4 bg-red-500 text-white text-xs flex items-center justify-center">
            {badge}
        </div> : null}
    </div>
}

export default BusinessSwitcher;
